import type { FunctionComponent } from 'react';
import { Suspense } from 'react';

import { ComponentWrapper } from '@trello/component-wrapper';
import {
  ChunkLoadErrorBoundary,
  ErrorBoundary,
} from '@trello/error-boundaries';
import { useLazyComponent } from '@trello/use-lazy-component';

interface Props {
  idList: string;
  idBoard: string;
  idOrganization: string | undefined;
}

export const LazyCreateListRulePopover: FunctionComponent<Props> = ({
  ...ids
}) => {
  const CreateListRulePopover = useLazyComponent(
    () =>
      import(
        /* webpackChunkName: "create-list-rule-popover" */ './CreateListRulePopover'
      ),
    { namedImport: 'CreateListRulePopover' },
  );

  return (
    <ComponentWrapper key="butlerCreateListRulePopover">
      <ErrorBoundary
        tags={{
          ownershipArea: 'trello-web-eng',
          feature: 'Butler on Boards',
        }}
      >
        <ChunkLoadErrorBoundary fallback={null}>
          <Suspense fallback={null}>
            <CreateListRulePopover {...ids} />
          </Suspense>
        </ChunkLoadErrorBoundary>
      </ErrorBoundary>
    </ComponentWrapper>
  );
};
